import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';

export interface IProps {
  className?: string;
  label?: string;
  labelPosition?: 'left' | 'center' | 'right';
}

const DividerWithLabel: FC<IProps> = (props) => {
  const { className, label, labelPosition = 'center' } = props;

  return (
    <>
      <div
        className={clstx(
          'flex items-center text-gray-800',
          labelPosition === 'left' &&
            'after:flex-1 after:border-t after:border-gray-200 after:ms-6',
          labelPosition === 'center' &&
            'before:flex-1 before:border-t before:border-gray-200 before:me-6 after:flex-1 after:border-t after:border-gray-200 after:ms-6',
          labelPosition === 'right' &&
            'before:flex-1 before:border-t before:border-gray-200 before:me-6',

          className
        )}
      >
        {label}
      </div>
    </>
  );
};

export default DividerWithLabel;
